// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"428":"c0e4bd94","787":"c9c6c068","920":"22c0df05","923":"b00aa859"}[chunkId] + ".chunk.js";
};